window.getValue = function getValue(value, array) {
    for (var i = 0; i <= array.length; i++) {
        if (array[i] == value) {
            var key = i;
        }
    }

    return key;
}

window.closest = function closest(num, arr) {
    var mid;
    var lo = 0;
    var hi = arr.length - 1;
    while (hi - lo > 1) {
        mid = Math.floor((lo + hi) / 2);
        if (arr[mid] < num) {
            lo = mid;
        } else {
            hi = mid;
        }
    }
    if (num - arr[lo] <= arr[hi] - num) {
        return arr[lo];
    }
    return arr[hi];
}

var delay = (function () {
    var timer = 0;
    return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
})();

window.cleanArray = function cleanArray(actual) {
    var newArray = new Array();
    for (var i = 0; i < actual.length; i++) {
        if (actual[i]) {
            newArray.push(actual[i]);
        }
    }
    return newArray;
}

window.slider_input = function slider_input(options) {
    var count = 0;
    options.array_length = options.slider_max / options.step;

    if (options.slider_min > 0) {
        options.start = 1;
    } else {
        options.start = 0;
    }

    for (var i = options.start; i < options.array_length; i++) {
        options.slider_array[i] = options.step * i;
    }

    if (options.slider_max_2) {
        count = i;
        options.array_length_2 = (options.slider_max_2 - options.slider_max) / options.step_2;
        for (var i = 0; i <= options.array_length_2; i++) {
            options.slider_array[i + count] = options.slider_max + (options.step_2 * i);
        }
    } else {
        options.slider_array[options.array_length] = options.step * options.array_length;
    }

    if ($(options.input).val()) {
        options.slider_start = $(options.input).val();
    }

    options.slider_start = closest(options.slider_start, options.slider_array);
    options.current_val = getValue(options.slider_start, options.slider_array)

    $(options.slider).slider({
        range: "min",
        min: options.slider_min / options.step,
        max: options.slider_array.length - 1,
        value: options.current_val,
        slide: function (event, ui) {
            var value = options.slider_array[ui.value];

            if (value === undefined) {
                value = 0;
            }

            change_input(value);
            // Finance Calculator
            if (options.calculate_finance) {
                // do stuff

                delay(function () {
                    financeCalculatorV1();
                }, 1000);
            }
        }
    });

    $(options.input).keyup(function (event) {
        // skip for arrow keys
        if (event.which >= 37 && event.which <= 40) return;
        var value = $(this).val();

        value = parseInt(value.replace(options.append, '').replace(options.prepend, ''));

        if (options.slider_max_2) {
            if (value >= options.slider_max_2) {
                value = options.slider_max_2;
            }
        } else {
            if (value >= options.slider_max) {
                value = options.slider_max;
            }
        }
        change_slider(options.slider_array, value);
        if (value) {
            change_input(value)
            // Finance Calculator
            if (options.calculate_finance) {
                // do stuff
                delay(function () {
                    financeCalculatorV1();
                }, 1000);
            }
        }

    });

    change_input($(options.input).val());

    function change_input(value) {
        var new_value = value;

        if (options.append) {
            new_value = options.append + new_value;
        }
        if (options.prepend) {
            new_value = new_value + options.prepend;
        }

        $(options.input).val(new_value);
    }

    function change_slider(slider_array, value) {
        var closest_val = closest(value, slider_array),
            closest_key = getValue(closest_val, slider_array);

        $(options.slider).slider("value", closest_key + 1);
    }

    $(options.input).mtcNumberArrows({
        up_arrow: '<img src="/sites/petervardy/images/svgs/plus-regular-white.svg" alt="Plus" />',
        down_arrow: '<img src="/sites/petervardy/images/svgs/minus-regular-white.svg" alt="Minus" />',
        disable_increment: true,
        disable_finance_calculator: true,
        onAdd: function (count) {

            var closest_val = closest(count, options.slider_array),
                closest_key = getValue(closest_val, options.slider_array);

            $(options.slider).slider("value", (closest_key + 1));

            var new_value = options.slider_array[closest_key + 1];
            if (options.append) {
                new_value = options.append + new_value;
            }
            if (options.prepend) {
                new_value = new_value + options.prepend;
            }

            $(options.input).attr('value', new_value);

            if (options.calculate_finance) {
                delay(function () {
                    financeCalculatorV1();
                }, 1000);
                // do stuff
            }
        },
        onSubtract: function (count) {
            var closest_val = closest(count, options.slider_array),
                closest_key = getValue(closest_val, options.slider_array);

            $(options.slider).slider("value", (closest_key - 1));

            var new_value = options.slider_array[closest_key - 1];
            if (new_value === undefined) {
                new_value = 0;
            }
            if (options.append) {
                new_value = options.append + new_value;
            }
            if (options.prepend) {
                new_value = new_value + options.prepend;
            }
            $(options.input).attr('value', new_value);

            if (options.calculate_finance) {
                delay(function () {
                    financeCalculatorV1();
                }, 1000);
                // do stuff
            }
        },
        onBeforeChange: function (count) {
            return parseInt(count.replace(options.append, '').replace(options.prepend, ''));
        }
    });
}


window.calculateFinance = function calculateFinance() {
    if (matchesMediaQuery(0, 800)) {
        $('.calculateFinance').show();
        $('.csFinanceInfo').hide();
    }
}

window.carstoreSliders = function carstoreSliders() {

    if (matchesMediaQuery(0, 670)) {
        if (!$('.js_csCtaWrap ul').hasClass('slick-initialized')) {
            $('.js_csCtaWrap ul').slick({
                dots: true,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 4000,
                speed: 1200,
                cssEase: 'ease-in-out',
            });
        }

    } else {
        if ($('.js_csCtaWrap ul').hasClass('slick-initialized')) {
            $('.js_csCtaWrap ul').slick('unslick');
        }
    }

    if (matchesMediaQuery(0, 400)) {
        // $('.js_csCtaSecondWrap .csCtaItem').matchHeight({
        //     byRow: false
        // });

        if (!$('.js_csCtaSecondWrap ul').hasClass('slick-initialized')) {
            $('.js_csCtaSecondWrap ul').slick({
                dots: true,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 4000,
                speed: 1200,
                cssEase: 'ease-in-out',
            });
        }

    } else {
        if ($('.js_csCtaSecondWrap ul').hasClass('slick-initialized')) {
            $('.js_csCtaSecondWrap ul').slick('unslick');
        }
    }
}

$(document).ready(function () {
    'use strict';

    slider_input({
        'input': '#carValue',
        'slider': '#carValueSlider',
        'slider_min': 0,
        'slider_max': 35000,
        'slider_max_2': 100000,
        'step': 500,
        'step_2': 1000,
        'slider_start': 7500,
        'slider_array': [],
        'calculate_finance' : true,
        'append': '£'
    });

    slider_input({
        'input': '#depositAmount',
        //'slider': '#depositAmountSlider',
        'slider_min': 0,
        'slider_max': 5000,
        'slider_max_2': 10000,
        'step': 200,
        'step_2': 200,
        'slider_start': 0,
        'slider_array': [],
        'calculate_finance' : true,
        'append': '£'
    });

    slider_input({
        'input': '#paybackTime',
        //'slider': '#depositAmountSlider',
        'slider_min': 12,
        'slider_max': 60,
        'step': 6,
        'slider_start': 60,
        'slider_array': [],
        'calculate_finance' : true,
        'prepend': ' months'
    });

    calculateFinance();

    $('.js_mobileTabs a').on('click', function(e) {
        e.preventDefault();

        if ($('loading').length == 0) {

            $('.js_mobileTabs li').removeClass('active');

            $(this).parent().addClass('active');

            if ($(this).parent().index() == 0) {
                $('.calculateFinance').show();
                $('.csFinanceInfo').hide();
            } else {
                $('.calculateFinance').hide();
                $('.csFinanceInfo').show();
            }
        }
    });

    carstoreSliders();
});